import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-cfg-macrophase-dialog',
  templateUrl: './cfg-macrophase-dialog.component.html',
  styleUrls: ['./cfg-macrophase-dialog.component.scss']
})
export class CfgMacrophaseDialogComponent {
  @Input() macroPhaseData: any;
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<any>();

  originalData: any;

  ngOnInit(): void {
    this.originalData = JSON.parse(JSON.stringify(this.macroPhaseData)); 
  }


  onSave() {
    if (this.isFormValid()) {
      this.save.emit(this.macroPhaseData);
    }
  }

  onClose() {
    this.close.emit();
  }

  isFormValid(): boolean {
    return (
      this.macroPhaseData?.name?.trim() &&
      this.macroPhaseData?.position != null
    );
  }
  isUnchanged(): boolean {
    return JSON.stringify(this.macroPhaseData) === JSON.stringify(this.originalData); // o macroPhaseData
  }

}
